<template>
  <Tabs
    @update:modelValue="handleSelectView"
    variant="button-primary"
    size="sm"
    orientation="horizontal"
    class="overflow-x-auto hide-scrollbar"
  >
    <Tab
      v-for="view in views"
      :key="view.id"
      :label="t(view.name)"
      :badge="view.count"
    />
  </Tabs>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Tabs, Tab } from "@/SharedComponents/Tabs";
import { useDefaultTasksViews } from "@/Pages/Tasks/Views";
import { useTasksViews } from "@/Composables/useTasksViews";

const { t } = useI18n();
const { customViews, isLoading } = useTasksViews();
const { defaultViews } = useDefaultTasksViews();

const views = computed(() => {
  return isLoading.value
    ? defaultViews
    : defaultViews.concat(customViews.value);
});

const emit = defineEmits(["change-view"]);

const handleSelectView = (index) => {
  emit("change-view", views.value[index]);
};
</script>
